import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { openTicket, transactionStatus, setOpenTicketStatus, calculateFee, setFeeDetails } from '../../../redux/actions/RegisterActions';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

const money = (value) => '$' + (isNaN(value) || value === null || value === undefined ? '0.00' : Number(value).toFixed(2))

const RegisterTransactionTest = (props) => {

    useNavigate()

    useState('')
    const [transactionType, setTransactionType] = useState('01')
    const [saleAmount, setSaleAmount] = useState('');
    const [cashbackAmount, setCashbackAmount] = useState('');
    const [printMerchantCopy, setPrintMerchantCopy] = useState('true')
    const [printCustomerCopy, setPrintCustomerCopy] = useState('true');
    const [ticketResponse, setTicketResponse] = useState(null)
    const [selectedFeeOption, setSelectedFeeOption] = useState('inclusive')


    const [transactionTypeError, setTransactionTypeError] = useState(false)
    const [amountError, setAmountError] = useState(false);
    const [printMerchantCopyError, setPrintMerchantCopyError] = useState(false)
    const [printCustomerCopyError, setPrintCustomerCopyError] = useState(false);

    const feeDetails = props.REGISTERREDUCER?.feeDetails

    const registerDetails = props.REGISTERREDUCER?.registerData && props.REGISTERREDUCER.registerData.length ? props.REGISTERREDUCER.registerData[0] : null
    const isCashForDebit = registerDetails ? (registerDetails.cashForDebit === true || registerDetails.cashForDebit === 'true' || registerDetails.cashForDebit === 1) : false


    const TRANSACTION_TYPE = [
        {
            'transactionType': '31',
            'label': 'Inquiry'
        },
        {
            'transactionType': '01',
            'label': 'Withdrawal'
        },
    ]

    const PRINT_YES_NO = [
        {
            'print': 'true',
            'label': 'Yes'
        },
        {
            'print': 'false',
            'label': 'No'
        },
    ]


    useEffect(() => {
        handleReset()
        props.setFeeDetails(null)
        return () => {
            props.setFeeDetails(null)
        }
    }, [])




    useEffect(() => {
        if (props.REGISTERREDUCER.ticketResponse) {
            setTicketResponse(props.REGISTERREDUCER.ticketResponse)
            console.log('Ticket Response : ', ticketResponse)
        }
    }, [props.REGISTERREDUCER])

    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'saleAmount':
                setSaleAmount(targetValue)
                setAmountError(false)
                break;
            case 'cashbackAmount':
                setCashbackAmount(targetValue)
                break;
            case 'transactionType':
                setTransactionType(targetValue)
                setTransactionTypeError(false)
                break;
            case 'printMerchantCopy':
                setPrintMerchantCopy(targetValue)
                setPrintMerchantCopyError(false)
                break
            case 'printCustomerCopy':
                setPrintCustomerCopy(targetValue)
                setPrintCustomerCopyError(false)
                break;
            default:
                break;
        }

    }

    const handleGetTransactionStatus = (event) => {
        event.preventDefault();
        props.setShowTransactionModelOpen(false)

    }

    // Builds and validates the common ticket fields shared by both flows.
    // Returns the body object if valid, or null if validation failed.
    const buildValidatedBody = () => {

        let valid = true
        let body = {}

        if (props.REGISTERREDUCER.registerID) {
            body.registerId = props.REGISTERREDUCER.registerID
        }

        if (transactionType) {
            body.transactionType = transactionType
            setTransactionTypeError(false)
        } else {
            setTransactionTypeError(true)
            valid = false
        }

        // Sale amount is only required for Withdrawal (01); cashback is optional.
        if (transactionType === '01') {
            if (saleAmount) {
                body.saleAmount = Number(saleAmount)
                body.cashbackAmount = Number(cashbackAmount) || 0
            } else {
                setAmountError(true)
                valid = false
            }
        }

        if (printCustomerCopy) {
            body.printCustomerCopy = printCustomerCopy
            setPrintCustomerCopyError(false);
        } else {
            setPrintCustomerCopyError(true)
            valid = false
        }

        if (printMerchantCopy) {
            body.printMerchantCopy = printMerchantCopy
            setPrintMerchantCopyError(false)
        } else {
            setPrintMerchantCopyError(true)
            valid = false
        }

        return valid ? body : null
    }

    // Step 1: validate, then for a Withdrawal calculate the fee first;
    // Inquiry has no fee so it opens the ticket directly.
    const handleCalculateFee = (event) => {

        event.preventDefault();

        const body = buildValidatedBody()
        if (!body) {
            return
        }

        const accessToken = props.REGISTERREDUCER?.registerData[0]?.registerAccessToken

        // Fee calculation only applies to cash-for-debit registers; otherwise
        // open the ticket directly with the entered amount.
        if (transactionType === '01' && isCashForDebit) {
            props.calculateFee({
                registerId: body.registerId,
                saleAmount: body.saleAmount,
                cashbackAmount: body.cashbackAmount
            }, accessToken)
        } else {
            if (transactionType === '01') {
                body.amount = body.saleAmount
            }
            props.openTicket(body, accessToken)
        }
    }

    // Step 2: open the ticket using the selected fee option.
    const handleConfirmTicket = (event) => {

        event.preventDefault();

        const body = buildValidatedBody()
        if (!body) {
            return
        }

        if (feeDetails) {
            // Only when fee override is allowed can the cashier choose between
            // inclusive/exclusive; otherwise the inclusive fee is applied.
            const feeInclusive = feeDetails.feeOverride ? selectedFeeOption === 'inclusive' : true
            body.feeId = feeDetails.feeId
            body.feeOverride = feeDetails.feeOverride
            body.feeInclusive = feeInclusive
            // Selected total sent as the ticket amount
            body.amount = feeInclusive ? feeDetails.feeInclusiveAmount : feeDetails.feeExclusiveAmount
            body.saleAmount = feeDetails.saleAmount
            body.cashbackAmount = feeDetails.cashbackAmount
        }

        props.openTicket(body, props.REGISTERREDUCER?.registerData[0]?.registerAccessToken)
    }

    // Go back from the fee selection screen to the entry form.
    const handleBack = (event) => {
        event.preventDefault();
        props.setFeeDetails(null)
    }

    const handleReset = (event) => {
        setSaleAmount('')
        setCashbackAmount('')
        setTransactionType('01')
        setPrintCustomerCopy('true')
        setPrintMerchantCopy('true')
        setAmountError(false)
        setPrintCustomerCopyError(false)
        setPrintMerchantCopyError(false)
        setSelectedFeeOption('inclusive')
    }

    return (

        <div style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: '#1c2230',
            borderRadius: '14px',
            padding: '14px',
            boxShadow: 'inset 0 0 0 4px #2b3245'
        }}>

            {/* Register display screen */}
            <div style={{
                background: 'linear-gradient(180deg, #0f3d2e 0%, #135c43 100%)',
                color: '#9affc8',
                fontFamily: 'monospace',
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '14px',
                textAlign: 'center',
                letterSpacing: '1px',
                boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.5)'
            }}>
                <div style={{ fontSize: '11px', opacity: 0.8 }}>*** POS REGISTER ***</div>
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    {feeDetails
                        ? money((feeDetails.feeOverride ? selectedFeeOption === 'inclusive' : true) ? feeDetails.feeInclusiveAmount : feeDetails.feeExclusiveAmount)
                        : money(saleAmount)}
                </div>
                <div style={{ fontSize: '11px', opacity: 0.8 }}>Register #{props.REGISTERREDUCER.registerID}</div>
            </div>

            <Panel style={{ flex: 1, overflowY: 'auto', marginBottom: 0 }}>

            <PanelHeader>{props.REGISTERREDUCER?.ticketStatus === false && feeDetails ? 'FEE DETAILS' : 'TRANSACTION PAGE - ' + props.REGISTERREDUCER.registerID}</PanelHeader>

            <PanelBody>

            {console.log('ticket Status ' + props.REGISTERREDUCER?.ticketStatus) }

                {(props.REGISTERREDUCER?.ticketStatus !== false) ?

                    <form className="fs-13px">

                        <div className="mb-3">

                            <div className="row gx-6">

                                <div className="col-md-12 mb-12 mb-md-2">
                                    <label className={"col-md-12"}><b>Transaction ID</b> {ticketResponse?.transactionId}</label>
                                </div>

                                <div className="col-md-12 mb-12 mb-md-2">
                                    <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleGetTransactionStatus}>{'Close'}</button>
                                </div>
                            </div>
                        </div>
                    </form> : feeDetails ?

                    /* Step 2: fee details + option selection */
                    <form className="fs-13px">

                        <div className="mb-3">

                            <label className="col-md-12 mb-1"><b>Fee Response</b></label>
                            <div style={{ fontFamily: 'monospace', border: '1px dashed #999', borderRadius: '6px', padding: '10px 14px', marginBottom: '12px' }}>
                                <div className="d-flex justify-content-between"><span>Fee ID</span><b style={{ fontSize: '11px', wordBreak: 'break-all' }}>{feeDetails.feeId}</b></div>
                                <div className="d-flex justify-content-between"><span>Fee Override</span><b>{feeDetails.feeOverride ? 'Yes' : 'No'}</b></div>
                                <div className="d-flex justify-content-between"><span>Sale Amount</span><b>{money(feeDetails.saleAmount)}</b></div>
                                <div className="d-flex justify-content-between"><span>Cashback Amount</span><b>{money(feeDetails.cashbackAmount)}</b></div>
                                <div className="d-flex justify-content-between"><span>Default Fee</span><b>{money(feeDetails.defaultFee)}</b></div>
                                <div className="d-flex justify-content-between"><span>Additional Fee</span><b>{money(feeDetails.additionalFee)}</b></div>
                            </div>

                            {feeDetails.feeOverride ?
                                <>
                                <label className="col-md-12 mb-2"><b>Select Fee Option</b></label>

                                <div className={"col-md-12 mb-2 p-2 " + (selectedFeeOption === 'inclusive' ? 'border border-primary rounded' : 'border rounded')}
                                    style={{ cursor: 'pointer' }} onClick={() => setSelectedFeeOption('inclusive')}>
                                    <label className="d-flex align-items-center" style={{ cursor: 'pointer', margin: 0 }}>
                                        <input type="radio" name="feeOption" className="me-2" checked={selectedFeeOption === 'inclusive'} onChange={() => setSelectedFeeOption('inclusive')} />
                                        <b>Fee Inclusive</b>
                                    </label>
                                    <div className="d-flex justify-content-between"><span>Total Charged</span><b>{money(feeDetails.feeInclusiveAmount)}</b></div>
                                    <div className="d-flex justify-content-between"><span>Customer Receives</span><b>{money(feeDetails.returnAmountFeeInclusive)}</b></div>
                                </div>

                                <div className={"col-md-12 mb-3 p-2 " + (selectedFeeOption === 'exclusive' ? 'border border-primary rounded' : 'border rounded')}
                                    style={{ cursor: 'pointer' }} onClick={() => setSelectedFeeOption('exclusive')}>
                                    <label className="d-flex align-items-center" style={{ cursor: 'pointer', margin: 0 }}>
                                        <input type="radio" name="feeOption" className="me-2" checked={selectedFeeOption === 'exclusive'} onChange={() => setSelectedFeeOption('exclusive')} />
                                        <b>Fee Exclusive</b>
                                    </label>
                                    <div className="d-flex justify-content-between"><span>Total Charged</span><b>{money(feeDetails.feeExclusiveAmount)}</b></div>
                                    <div className="d-flex justify-content-between"><span>Customer Receives</span><b>{money(feeDetails.returnAmountFeeExclusive)}</b></div>
                                </div>
                                </>
                                :
                                <div className="col-md-12 mb-3 p-2 border rounded">
                                    <div className="d-flex justify-content-between"><span>Total Charged</span><b>{money(feeDetails.feeInclusiveAmount)}</b></div>
                                    <div className="d-flex justify-content-between"><span>Customer Receives</span><b>{money(feeDetails.returnAmountFeeInclusive)}</b></div>
                                </div>
                            }

                            <div className="col-md-12 mb-12 mb-md-2">
                                <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleConfirmTicket}>{'Confirm & Open Ticket'}</button>
                            </div>
                            <div className="col-md-12 mb-12 mb-md-2">
                                <button className='btn btn-gray d-block w-100 btn-lg h-9px fs-13px' onClick={handleBack}>{'Back'}</button>
                            </div>
                        </div>
                    </form> :

                    <form className="fs-13px">

                        <div className="mb-3">

                            <div className="row gx-6">

                                <div className="col-md-12 mb-12 mb-md-2">

                                    <label className={"col-md-6 " + (printCustomerCopyError ? 'text-danger' : '')}><b>Transaction Type</b></label>
                                    <select className="form-select"
                                        value={transactionType ? transactionType : ''}
                                        onChange={handleChange}
                                        name='transactionType'
                                    >
                                        <option value=''>Select Transaction Type</option>
                                        {TRANSACTION_TYPE.map((option) => (
                                            <option key={option.transactionType} value={option.transactionType}>
                                                {option.label}
                                            </option>
                                        ))}

                                    </select>
                                </div>

                                {(transactionType === '01') ?

                                    (isCashForDebit ?
                                    <>
                                    <div className="col-md-6 mb-12 mb-md-2">

                                        <label className={"col-md-12 " + (amountError ? 'text-danger' : '')}><b>Sale Amount</b></label>
                                        <input type="number" className="form-control fs-13px"
                                            value={saleAmount}
                                            onChange={handleChange}
                                            name='saleAmount'
                                        />
                                    </div>

                                    <div className="col-md-6 mb-12 mb-md-2">

                                        <label className={"col-md-12"}><b>Cashback Amount</b></label>
                                        <input type="number" className="form-control fs-13px"
                                            value={cashbackAmount}
                                            onChange={handleChange}
                                            name='cashbackAmount'
                                        />
                                    </div>
                                    </>
                                    :
                                    <div className="col-md-12 mb-12 mb-md-2">

                                        <label className={"col-md-12 " + (amountError ? 'text-danger' : '')}><b>Amount</b></label>
                                        <input type="number" className="form-control fs-13px"
                                            value={saleAmount}
                                            onChange={handleChange}
                                            name='saleAmount'
                                        />
                                    </div>
                                    )

                                    : null}

                            </div>


                            <div className="col-md-12 mb-12 mb-md-2">

                                <label className={"col-md-12 " + (printCustomerCopyError ? 'text-danger' : '')}><b>Customer Copy</b></label>
                                <select className="form-select"
                                    value={printCustomerCopy ? printCustomerCopy : ''}
                                    onChange={handleChange}
                                    name='printCustomerCopy'
                                >
                                    <option value=''>Select Print Customer Receipt</option>
                                    {PRINT_YES_NO.map((option) => (
                                        <option key={option.print} value={option.print}>
                                            {option.label}
                                        </option>
                                    ))}

                                </select>
                            </div>

                            <div className="col-md-12 mb-12 mb-md-2">
                                <label className={"col-md-12 " + (printMerchantCopyError ? 'text-danger' : '')}><b>Merchant Copy</b></label>

                                <select className="form-select"
                                    value={printMerchantCopy ? printMerchantCopy : ''}
                                    onChange={handleChange}
                                    name='printMerchantCopy'
                                >

                                    <option value=''>Select Print Merchant Copy</option>
                                    {PRINT_YES_NO.map((option) => (
                                        <option key={option.print} value={option.print}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-12 mb-12 mb-md-2">
                                <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleCalculateFee}>{transactionType === '01' && isCashForDebit ? 'Calculate Fee' : 'Initiate Transaction'}</button>
                            </div>
                            {/* 
                        <div className="col-md-12 mb-12 mb-md-2">
                                <button className='btn btn-gray d-block w-100 btn-lg h-9px fs-13px' onClick={handleResetPreventingRefresh}>Reset</button>

                        </div> */}
                        </div>
                    </form>
                }

            </PanelBody >


            </Panel >

        </div>

    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    openTicket,
    transactionStatus,
    setOpenTicketStatus,
    calculateFee,
    setFeeDetails

}


export default connect(mapStateToProps, mapDispatchToProps)(RegisterTransactionTest);